import React, { useEffect, useState } from 'react';
import { subscribe } from '../utility/eventEmitter';

export default function Banishment({ children }) {
  const [isOpen, setIsOpen] = useState(false);
  const [message, setMessage] = useState('');
  const [data, setData] = useState({ email: '', uid: '', phone: '' });

  function block(error) {
    setIsOpen(true);
    setMessage(error?.message || 'Your account has been blocked.');
    setData(error?.data);
  }

  useEffect(() => {
    const unsubscribe = subscribe('blocked', block);

    return () => {
      unsubscribe();
    };
  }, []);

  function writeToSupport() {
    const subject = 'Account Banishment';
    const user = `User Details:
    UID: ${data?.uid || 'N/A'}
    Phone: ${data?.phone || 'N/A'}`;
    const body = `I am writing to you because my account has been blocked. Please help me to resolve this issue.\n\n${data?.uid ? user : ''}`;
    window.open(`mailto:support@gesture.vip?subject=${subject}&body=${body}`);
  }

  function clickableMessage() {
    if (!message?.includes?.('support@gesture.vip')) {
      return [message];
    }

    return message.split('support@gesture.vip').map((part, index) => {
      const key = `part-${index}`;
      const template = part;

      if (index !== 0) {
        return (
          <React.Fragment key={`${key}-fragment`}>
            <a key={`${key}-link`} href="#" className="text-info" onClick={() => writeToSupport()}>
              support@gesture.vip
            </a>
            {template}
          </React.Fragment>
        );
      }
      return template;
    });
  }

  if (isOpen) {
    return (
      <div className="d-flex h-100 justify-content-center align-items-center">
        <p className="h5 p-5 text-center">{clickableMessage()}</p>
      </div>
    );
  }

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>;
}
